import Menu from "../components/Menu";
import Payment from "../components/Payment";
import Policy from "../components/PolicyLinks/Policy";
import HappyBirthday from "../components/HappyBirthday";
import Renewal from "../components/Renewal";
import RoundyContainer from "../components/RoundyContainer";
import { verifyLoginTkn, checkPBTStatus } from "../services/Api";
import { Spinner } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import { storageData } from "../services/Services";
import OptInModal from "../components/OptInModal";
import { useEffect, useState } from "react";
import SelfServiceMsg from "../components/SelfServiceMsg";
import MaintenanceMsg from "../components/MaintenanceMsg";
import TextToPayInstructionsModal from "../components/TextToPayInstructionsModal"; 
import RenewalAlertModal from "../components/RenewalAlertModal/RenewalAlertModal";
import SecurityQAsModal from "components/SecurityQAsModal";


const Content = (props) => {
    return (
        <>
            <div className="row">
                <div className="col-12 col-md-6 pb-5">
                    <Payment {...props} />
                </div>
                <div className="col-12 col-md-6" >
                    <Policy {...props} />
                </div>
            </div>
        </>
    )
}

const ContentFooter = (props) => {
    const userData = props.userData

    // Birthday check
    var bday = new Date(userData.dob);
    var currDate = new Date();
    var bdayCheck = (bday.getMonth() + 1) === (currDate.getMonth() + 1) && bday.getDate() === currDate.getDate() ? true : false

    return (
        <>
            <div className="row">
                {bdayCheck &&
                    <HappyBirthday />
                }
                <div className="px-5 mt-1">
                    <Renewal {...props} />
                </div>
            </div>
        </>
    )
}


const Home = (props) => {
    const { userData, setUserData } = props.user
    const { renewalInfo } = userData
    const [complete, setComplete] = useState(userData?.complete)
    const location = useLocation()
    const [showSecurityQAsModal, setShowSecurityQAsModal] = useState(false)
    let params = new URLSearchParams(location.search);
    const [modalsList, setModalsList] = useState([])

    useEffect(() => {
        // Order to show modals:
        // 1. Renewal Pop Up
        if (!renewalInfo?.hasCompletedRenewal && 
            (
                (renewalInfo?.daysUntilRenewal > 37 && renewalInfo?.pipOption > 3) ||
                (renewalInfo?.daysUntilRenewal <= 37 && renewalInfo?.pipOption > 3 && renewalInfo?.renewalPIPOption < 4)
            ) && 
            !storageData.getItem('renewalModalAnswered')) {
            setModalsList(modalsList => modalsList.concat("renewal"));
            return;
        }
        
        // 2. Opt In/Out Pop Up
        if (!userData?.optedInOut && !storageData.getItem('optInOutAnswered')) {
            setModalsList(modalsList => modalsList.concat("opt"));
            return;
        }
        // Check if user needs to answer security questions, if so show Security Q&As Popup
        if(userData.securityPopup){
            setShowSecurityQAsModal(true);
        }
    }, [])

    useEffect(() => {
        // Removes the disclosure modal field from userData
        if ("disclosureModal" in userData) {
            delete userData.disclosureModal;
            storageData.setItem("userData", JSON.stringify(userData));
        }

        return () => { };
    }, [complete, params, userData]);

    const checkModalInList = (modalName) => {
        return modalsList[0] === modalName;
    }

    const setupUser = async () => {
        if (!complete && params.has("tkn")) {
            storageData.setItem("token", params.get("tkn"))
            setComplete(true);
            var response = await verifyLoginTkn(params.get("tkn"), "")
            if (response.data.Result === "Success") {
                response.data.idCardData = response.data.idCardData.result
                response.data.renewalData = response.data.renewalData != null ? response.data.renewalData.result : ""
                // Call checkPBTStatus and add the result to userData
                var responsePBT = await checkPBTStatus(response.data.policyNumber, response.data.env, response.data.token)
                var textToPay = responsePBT[0]?.ResultCode === "Success" || responsePBT?.ResponseCode === "Success" ? responsePBT[0].TextSubscriptionStatus === "OptedIn" : false;
                response.data.textToPay = textToPay; // Add new field to userDatas
                setUserData({ ...response.data, login: "my-account", complete: true })
                window.location.href = "/home"
            }
            else {
                window.location.href = "/"
            }
        } else {
            window.location.href = "/"
        }
    }
    //console.log("complete:" + complete);
    if (!complete && params.has("tkn")) {
        setupUser()
    } else if (userData?.login == "quick-service") {
        window.location.href = "/quick-service"
    } else if (complete && userData.idCardData != null && params.has("tkn")) {
        window.location.href = "/home";
    }

    const InitContentFooter = () => (<ContentFooter userData={userData} />)

    return (
        <>
            {
                (complete && !params.has("tkn")) &&
                <>
                    {userData?.renewalInfo != null &&
                        <RenewalAlertModal userData={userData} showModal={checkModalInList("renewal")} setShowModal={setModalsList} />
                    }
                    <OptInModal userData={userData} showModal={checkModalInList("opt")} setShowOptInModal={setModalsList} />
                    <SecurityQAsModal showModal={showSecurityQAsModal} setShowSecurityQAsModal={setShowSecurityQAsModal}/>
                    <Menu Title={"MY ACCOUNT"} FirstName={userData.firstName} userData={userData} />
                    <SelfServiceMsg userData={userData} />
                    <MaintenanceMsg />
                    {/* <RoundyContainer params={props} Content={Content} ContentFooter={InitContentFooter} /> */}
                    <RoundyContainer 
                        params={props} 
                        Content={(contentProps) => <Content {...contentProps} />} 
                        ContentFooter={InitContentFooter} 
                    />
                </>
            }
            {
                (!complete || params.has("tkn")) &&
                // <Landing />
                <div style={{ display: "flex", position: "absolute", top: "50%", left: "50%" }}>
                    <Spinner animation="border" />
                </div>
            }
        </>
    );
};

export default Home;